import type {
  CustomerNotification,
  CustomerNotificationUnreadCount,
  ListCustomerNotificationsResponse,
  NotificationReadResponse,
  RegisterNotificationDeviceInput,
  RegisterNotificationDeviceResponse,
} from '@mbbe/types';
import { destekApiFetch } from './destekApiClient';

export type { CustomerNotification };

const DEVICE_STORAGE_KEY = 'mbbe_destek_notification_device_id';

export interface ListNotificationsParams {
  limit?: number;
  offset?: number;
  filter?: 'all' | 'unread' | 'action_required';
  unreadOnly?: boolean;
}

export function listNotifications(params: ListNotificationsParams = {}): Promise<ListCustomerNotificationsResponse> {
  const qs = new URLSearchParams();
  if (params.limit != null) qs.set('limit', String(params.limit));
  if (params.offset != null) qs.set('offset', String(params.offset));
  if (params.filter && params.filter !== 'all') qs.set('filter', params.filter);
  if (params.unreadOnly) qs.set('unreadOnly', 'true');
  const query = qs.toString();
  return destekApiFetch(`/destek/notifications${query ? `?${query}` : ''}`);
}

export function getUnreadNotificationCount(): Promise<CustomerNotificationUnreadCount> {
  return destekApiFetch('/destek/notifications/unread-count');
}

export function markNotificationRead(id: string): Promise<NotificationReadResponse> {
  return destekApiFetch(`/destek/notifications/${id}/read`, { method: 'POST' });
}

export function markNotificationsReadByIssue(issueId: string): Promise<NotificationReadResponse> {
  return destekApiFetch(`/destek/notifications/read-by-issue/${issueId}`, { method: 'POST' });
}

export function markAllNotificationsRead(): Promise<NotificationReadResponse> {
  return destekApiFetch('/destek/notifications/read-all', { method: 'POST' });
}

export function markAllNotificationsSeen(): Promise<NotificationReadResponse> {
  return destekApiFetch('/destek/notifications/seen-all', { method: 'POST' });
}

export function markIssueNotificationsRead(issueId: string): Promise<NotificationReadResponse> {
  return markNotificationsReadByIssue(issueId);
}

export async function registerNotificationDevice(body: RegisterNotificationDeviceInput) {
  const response = await destekApiFetch<RegisterNotificationDeviceResponse>('/destek/notification-devices', {
    method: 'POST',
    body: JSON.stringify(body),
  });
  localStorage.setItem(DEVICE_STORAGE_KEY, response.id);
  return response;
}

export async function revokeStoredNotificationDevice() {
  const id = localStorage.getItem(DEVICE_STORAGE_KEY);
  if (!id) return;
  await destekApiFetch<NotificationReadResponse>(`/destek/notification-devices/${id}`, { method: 'DELETE' }).finally(() => {
    localStorage.removeItem(DEVICE_STORAGE_KEY);
  });
}
